import { render, staticRenderFns } from "./ViewWarehouse.vue?vue&type=template&id=edfc73d0"
import script from "./ViewWarehouse.vue?vue&type=script&lang=js"
export * from "./ViewWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports